import ShareResource from './ShareResource';
export default ShareResource;